var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-award-audit-detail',{staticClass:"pt-points-reward-detail__withData",attrs:{"pointsRewardsDetail":_vm.pointsRewardsDetail,"detailLoading":_vm.detailLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }